import { useEffect, useState } from "react";
import { MessageCircle, Phone } from "lucide-react";
import { waLink } from "../lib/wa";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Floating Call + WhatsApp button. Admin-configurable number via /public/settings.
 * Sticky bottom-right, always visible.
 */
export default function WhatsAppFab() {
  const [number, setNumber] = useState(null);
  useEffect(() => {
    fetch(`${API}/public/settings`).then((r) => r.json()).then((d) => setNumber(d.floating_number)).catch(() => {});
  }, []);

  const digits = (number || "").replace(/\D/g, "");
  const waHref = number
    ? `https://wa.me/${digits}?text=${encodeURIComponent("Hi HeylpMate! I need a helping hand — can you get me a Mate?")}`
    : waLink("Hi HeylpMate! I need a helping hand — can you get me a Mate?");
  const telHref = digits ? `tel:+${digits}` : null;

  return (
    <div className="fixed z-40 bottom-5 right-5 md:bottom-7 md:right-7 flex flex-col gap-2 items-end">
      {telHref && (
        <a
          href={telHref}
          data-testid="call-fab"
          aria-label="Call HeylpMate"
          className="group relative"
        >
          <span className="absolute inset-0 rounded-full opacity-60 animate-ping" style={{ background: "#00604A", animationDuration: "2.6s" }} />
          <span className="relative flex items-center gap-2 rounded-full pl-4 pr-5 py-3 shadow-2xl transition-transform group-hover:scale-105"
                style={{ background: "#00604A", color: "#fff" }}>
            <Phone className="w-5 h-5" strokeWidth={2.4} />
            <span className="hidden md:inline font-bold text-sm">Call us</span>
          </span>
        </a>
      )}
      <a
        href={waHref}
        target="_blank" rel="noreferrer noopener"
        data-testid="whatsapp-fab"
        aria-label="Chat with HeylpMate on WhatsApp"
        className="group relative"
      >
        <span className="absolute inset-0 rounded-full opacity-70 animate-ping" style={{ background: "#25D366", animationDuration: "2.6s" }} />
        <span className="relative flex items-center gap-2 rounded-full pl-4 pr-5 py-3 shadow-2xl transition-transform group-hover:scale-105"
              style={{ background: "#25D366", color: "#fff" }}>
          <MessageCircle className="w-5 h-5" fill="#fff" strokeWidth={0} />
          <span className="hidden md:inline font-bold text-sm">Chat with a Mate</span>
        </span>
      </a>
    </div>
  );
}
